import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { WhatYouTriedSection } from '../components/WhatYouTriedSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full overflow-hidden selection:bg-sage selection:text-cream" data-id="element-235">
      <HeroSection data-id="element-236" />
      <OpeningHookSection data-id="element-237" />
      <WhatYouTriedSection data-id="element-238" />
      <MechanismSection data-id="element-239" />
      <WhatYouGetSection data-id="element-240" />
      <HowItWorksSection data-id="element-241" />
      <ForWhomSection data-id="element-242" />
      <ProofSection data-id="element-243" />
      <FAQSection data-id="element-244" />
      <PricingSection data-id="element-245" />
      <FinalCTA data-id="element-246" />
      <Footer data-id="element-247" />
    </main>;
}